import { render, staticRenderFns } from "./ImportSettings.vue?vue&type=template&id=9e191396&scoped=true"
import script from "./ImportSettings.vue?vue&type=script&lang=ts"
export * from "./ImportSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e191396",
  null
  
)

export default component.exports